export default {
  name: 'SelectList',
  icon: 'example-thumbnail.png',
  displayName: {
    en: 'SelectList',
    ja: 'プラグイン名',
  },
  defaultWidth: 155,
  defaultHeight: 44,
  minWidth: 100,
  resizeX: 'true',
  resizeY: 'true',
  props: [
    {
      name: 'value',
      type: 'string',
      role: 'formValue',
      enabled: {
        selectDatabase: false,
      },
    },
    {
      name: 'value',
      type: 'object',
      role: 'formValue',
      enabled: {
        selectDatabase: true,
      },
      reference: 'items',
    },
    {
      name: 'selectDatabase',
      displayName: {
        ja: 'データベースの選択',
        en: 'Select Database',
      },
      type: 'switch',
      default: true,
    },
    {
      name: 'itemsSeparate',
      displayName: {
        ja: '項目のリスト',
        en: 'List of Items',
      },
      placeholder: {
        ja: '改行ごとに選択項目が追加されます',
        en: 'Enter items separated by a breaking line',
      },
      disableDynamicValues: true,
      area: true,
      type: 'text',
      enabled: {
        selectDatabase: false,
      },
    },
    {
      name: 'items',
      displayName: {
        en: 'What is this a list of?',
        ja: 'データベースの選択',
      },
      type: 'list',
      enabled: {
        selectDatabase: true,
      },
    },
    {
      name: 'color',
      displayName: {
        en: 'color',
        ja: 'color',
      },
      type: 'color',
      default: 'black',
    },
    {
      name: 'backgroundColor',
      type: 'color',
      displayName: {
        en: 'BackgroundColor',
        ja: 'BackgroundColor',
      },
      default: '#fff',
    },
    {
      name: 'borderColor',
      displayName: {
        en: 'Border Color',
        ja: 'Border Color',
      },
      type: 'color',
      default: 'transparent',
      enabled: {
        border: 'true',
      },
    },
    {
      name: 'borderRadius',
      type: 'number',
      displayName: {
        en: 'Border Radius',
        ja: 'Border Radius',
      },
      enabled: {
        showProp: true,
      },
      default: 1,
    },
    {
      name: 'borderWidth',
      displayName: {
        en: 'Border Width',
        ja: 'Border Width',
      },
      type: 'number',
      default: 1,
      enabled: {
        bottomBorder: true,
      },
    },
    {
      name: 'action',
      type: 'action',
      displayName: {
        en: 'Button',
        ja: 'ClickFlow',
      },
    },
  ],
  childComponents: [
    {
      name: 'title',
      displayName: { en: 'Title', ja: 'タイトル' },
      props: [
        {
          name: 'text',
          displayName: { en: 'Text', ja: 'テキスト' },
          type: 'text',
          default: 'Title',
        },
      ],
    },
    {
      name: 'subTitle2',
      displayName: { en: 'Content', ja: 'コンテンツ' },
      props: [
        {
          name: 'text',
          displayName: { en: 'Text', ja: 'テキスト' },
          type: 'text',
          default: 'Content',
        },
        {
          name: 'enabled',
          type: 'boolean',
          default: 'false',
        },
      ],
    },
    {
      name: 'subTitle',
      displayName: { en: 'Option Content', ja: 'オプションコンテンツ' },
      role: 'listItem',
      reference: 'items',
      enabled: {
        selectDatabase: true,
      },
      props: [
        {
          name: 'text',
          displayName: { en: 'Text', ja: 'テキスト' },
          type: 'text',
          default: 'Content',
        },
      ],
    },
    {
      name: 'defaultData',
      displayName: { en: 'Default value', ja: '初期値' },
      reference: 'items',
      enabled: {
        selectDatabase: true,
      },
      props: [
        {
          name: 'text',
          displayName: { en: 'Text', ja: 'テキスト' },
          type: 'object',
        },
      ],
    },
    {
      name: 'defaultSeparate',
      displayName: { en: 'Default value', ja: '初期値' },
      enabled: {
        selectDatabase: false,
      },
      props: [
        {
          name: 'text',
          displayName: { en: 'Text', ja: 'テキスト' },
          type: 'text',
        },
      ],
    },
  ],
};
